import { observer } from "mobx-react";
import { useEffect, useState } from "react";

import ActionLink from "./ActionLink/ActionLink";

import "./ActivityList.scss";

const ActivityList = observer(({ store, selectedActions, onActionSelect, isMobile }) => {
  const [isAnimated, setIsAnimated] = useState(false);
  const { market } = store.currentMarketStore;

  useEffect(() => {
    setIsAnimated(true);
    const timer = setTimeout(() => setIsAnimated(false), 300);
    return () => clearTimeout(timer);
  }, [market]);

  return (
    <div className={`activity-list ${isAnimated ? "animated" : ""}`}>
      <div className={`activity-list__container ${isAnimated ? "animated" : ""}`}>
        {market.mainPageTitles.map((action, index) => (
          <ActionLink
            key={index}
            action={{
              ...action,
              titleComment: action.titleComment,
              icon: action.iconHome,
            }}
            isMobile={isMobile}
            isAnimated={isAnimated}
            target={action.target}
            isSelected={selectedActions.some((a) => a.index === index)}
            onSelect={() => onActionSelect({ ...action, index })}
          />
        ))}
      </div>
    </div>
  );
});

export default ActivityList;